export default __webpack_public_path__ + "static/media/m_wdt_c_2.12dd828b.mp3";